import * as React from "react";

const CopyStrokeRegularIcon = ({ color = "#ffffff", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M7.875 7.875H10.125V1.875H4.125V4.125"
      stroke={color}
      strokeWidth={0.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.875 4.125H1.875V10.125H7.875V4.125Z"
      stroke={color}
      strokeWidth={0.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CopyStrokeRegularIcon;
